import React from 'react';

import './WpHelpText.scss';

export interface Props {
  message: string | React.ReactNode;
  /** Unique identifier of the iof the form input */
  id?: string;
}

const WpHelpText = ({ message, id }: Props) => {
  if (!message) {
    return null;
  }

  return (
    <span className="WpHelpText" id={id && `${id}HelpText`}>
      {message}
    </span>
  );
};

export default WpHelpText;
